import type { TagFilters } from '../types';

export const TAG_KEYS = {
  all: ['tags'] as const,
  byProject: (orgId: string, projectId: string) => ['tags', orgId, projectId] as const,
  list: (orgId: string, projectId: string, filters: TagFilters) =>
    ['tags', orgId, projectId, 'list', filters] as const,
};
